import o from "./index.vue2.js";
import "./index.vue3.js";
import r from "../../../../_virtual/_plugin-vue_export-helper.js";
const e = /* @__PURE__ */ r(o, [["__scopeId", "data-v-1e5a0e47"]]);
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/GroundMass/index.vue.js
// module id = 1193
// module chunks = 41